import React from 'react';
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import swal from 'sweetalert';
import axios from 'axios';



class AlignedWorkflow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allTypes: [],
            showChidComponent: false,
            selectedid: '',
            List: [],
            message: "",
            searchVal: '',
        }
    }
    componentDidMount() {
        if (sessionStorage.getItem('User_reports_info') == null || sessionStorage.getItem('User_reports_info') == undefined || sessionStorage.getItem('User_reports_info') === "") {
            window.location.href = '/create/userlistreport'
            return
        }
        if (sessionStorage.getItem('report_info_session_siteadmin') == null || sessionStorage.getItem('report_info_session_siteadmin') == undefined || sessionStorage.getItem('report_info_session_siteadmin') === "") {
            window.location.href = '/create/alignedworkflowsiteadmin'
            return
        }
        this.fetch_aligned_workflow();
    }
    search_bar = (e) => {
        return
        let arr = this.state.tempList;
        if (arr.length === 0) {
            return
        }
        let findValue = e.target.value.toLowerCase()

        let b = arr.filter(item => item.workflow_name.toLowerCase().indexOf(findValue) > -1)
        this.setState({ List: b, searchVal: e.target.value })

    }
    closeSearch = () => {
        this.setState({ List: this.state.tempList, searchVal: "" })
    }
    fetch_aligned_workflow = () => {
        var user_id = JSON.parse(sessionStorage.getItem('User_reports_info')).login_id
        var data = {
            user_id: user_id,
            workflow_id: JSON.parse(sessionStorage.getItem('report_info_session_siteadmin')).workflow_id,

        }
        var _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/workflowFetchSessions`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.sessionsData.length > 0) {
                        var raw_arr = response.data.sessionsData;
                        _this.setState({ List: raw_arr })
                    }
                    else {
                        _this.setState({ List: [], message: "No Record Found" })
                    }

                }else{
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.fetch_aligned_workflow();
                        }
                    })
                }

            })
            .catch(function (error) {
                swal("Something Went Wrong,Please Retry")
            });
    }
    ReportsView = (list) => {
        sessionStorage.setItem('report_info_version_siteadmin', JSON.stringify(list));
        window.location.href = "/create/reportworkflowsiteadmin"
    }

    render() {
       
        return (
            <div>
                <div className="xp-breadcrumbbar">
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <h4 className="xp-page-title">Workflow Session</h4>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <div className="xp-breadcrumb gradient-border">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i className="icon-home"></i></a></li>
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/create/userlistreport"}>User List</a></li>
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/create/alignedworkflowsiteadmin"}>Aligned Workflow</a></li>

                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xp-contentbar p-30">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card document_gradient_border padding-0 border-before-15 m-b-30">
                                <div className="card-header">
                                    <div className="dv-center space-between">
                                        <h5 className="card-title mb-0">{JSON.parse(sessionStorage.getItem('report_info_session_siteadmin')).workflow_name}</h5>
                                        {/* <div className="autocomplete_search">
                                            <input type="text" className="form-control ml-2" onChange={this.search_bar} name="" value={this.state.searchVal} placeholder="Search Workflow ..." />
                                            {this.state.searchVal === "" ?
                                                <span className="icon-search">
                                                    <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path><path d="M0,0h24v24H0V0z" fill="none"></path></svg>
                                                </span>
                                                :
                                                <span className="icon-close-search">
                                                    <svg focusable="false" height="24px" onClick={this.closeSearch} viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                                                </span>
                                            }
                                        </div> */}
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        {this.state.List.length === 0 ?
                                            this.state.message === "" ?
                                                // loader
                                                <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                                                // loader-end
                                                :
                                                <div className="message-no-record"> {this.state.message} </div>
                                            : null}
                                        <div>
                                            <table className="table table-striped table-bordered ">
                                                <thead>
                                                    <tr>
                                                        <th>S.N.</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Version</th>
                                                        <th>Status</th>
                                                        <th>Reports</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.List.map((list, index) =>
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{list.start_date}</td>
                                                            <td>{list.end_date}</td>
                                                            <td>{list.version_name}</td>
                                                            <td>{list.complete_percentage == "100" ?
                                                                <i class="fa fa-check " style={{ color: "green", fontSize: "25px" }} aria-hidden="true"></i>
                                                                :
                                                                <i class="fa fa-spinner" style={{ color: "rgb(255 1 1)", fontSize: "25px" }} aria-hidden="true"></i>

                                                            }
                                                            </td>
                                                            {/* <td><div className="progress">
                                                                <div className="progress-bar bg-info" style={{ width: `${list.complete_percentage}%` }}>{list.complete_percentage}%</div>
                                                            </div></td> */}
                                                            <td>
                                                                <div className="tabledit-toolbar btn-toolbar" style={{ textAlign: "left" }}>
                                                                    <div className="btn-group btn-group-sm" style={{ float: "none" }}>
                                                                        <button type="button" disabled={list.complete_percentage == "100" ? false : true} onClick={() => this.ReportsView(list)} className=" btn  btn-info">See Reports</button>
                                                                        {/* <button type="button" className="btn btn-sm btn-primary">Delete </button> */}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AlignedWorkflow